module.exports = __webpack_public_path__ + "img/management.24260236.jpg";